



























import {Component, Vue} from "vue-property-decorator";
import {mapGetters} from "vuex";
import {format} from "date-fns";
import Game from "@/model/Game";
import TimeUtils from "@/services/TimeUtils";

@Component({
  computed: {
    ...mapGetters({
      scrims: "scrims"
    })
  }
})
export default class Scrims extends Vue {
  protected scrims!: Game[];
  private xiGameIds = [
    "ZWZheWFfdjJfbXBfZWZhX21hcmtldF8wLjgzNDQzNTA1NTM0NDkzMTM=",
    "ZWZheWFfdjJfbXBfY2FyZW50YW5fMC42MjM2Njk1ODgyNDU5Njkx",
    "ZWZheWFfdjJfbXBfY3Jhc2hfMC41NzY2ODA2NzkzMjkwOA==",
    "ZWZheWFfdjJfbXBfc3RyaWtlXzAuOTUzMDUxNDI1ODAwMzc3OQ==",
  ];
  private rejekzGameIds = [
    "ZWZheWFfdjJfbXBfZWZhX2NhbmFsc18wLjA2MDM4NzMzNTg3MTAxNzYz",
    "ZWZheWFfdjJfbXBfZGVzdHJveWVkX3ZpbGxhZ2VfMC4zMjQzMDQyMzM1NTc4ODc4NA==",
    "ZWZheWFfdjJfbXBfYml0dGVyXzAuMzU5MTAyNzI5NTI5ODYxNjY=",
  ];

  public duration(game: Game) {
    if (game.gameRefs[0].startTime) {
      const duration = (game.gameRefs[0].endTime - game.gameRefs[0].startTime) + (game.gameRefs[1].endTime - game.gameRefs[1].startTime);
      return TimeUtils.getReadableDiffTime(duration);
    }
    return null;
  }

  public isEfayaMod(game: Game) {
    return game.mod.startsWith("efaya_mod");
  }

  public isEfayaModV2(game: Game) {
    return game.mod.startsWith("efaya_v2");
  }

  public isIMMMod(game: Game) {
    return game.mod.startsWith("imm");
  }

  public isWW2Mod(game: Game) {
    return game.mod.startsWith("ww2");
  }

  public isPromod(game: Game) {
    return game.mod.startsWith("pml");
  }

  public formatDate(date: Date): string {
    return !isNaN(date.getTime()) ? format(date, "dd/MM/yyyy") : "";
  }

  public goToGame(game: Game) {
    this.$router.push("/game/scrims" + game.id);
  }

  public mapNamer(mapName: string): string {
    return mapName.replace("mp_", "").replace(/_/g, " ").toUpperCase();
  }

  public opponent(game: Game): string {
    if (this.xiGameIds.indexOf(game.id) > -1 ) {
      return "XI";
    } else {
      if (this.rejekzGameIds.indexOf(game.id) > -1 ) {
            return "Rejekz";
          }
    }
    return "N/A";
  }
}
